import Modal from '../../common/components/feedback/Modal'

export const disclaimerModal = (onCancel: () => void, translate: any) => {
  Modal.confirm({
    title: translate('ee-signup.disclaimer-modal.title'),
    content: translate('ee-signup.disclaimer-modal.content'),
    onOk() {},
    onCancel() {
      onCancel()
    },
    okText: translate('ee-signup.disclaimer-modal.stay'),
    okType: 'primary',
    cancelText: translate('ee-signup.disclaimer-modal.cancel'),
  })
}
